
import {Options, Vue} from "vue-class-component";
import DemandEdit from "@/components/demand/DemandEdit.vue";
import store from "@/store";
import {ActionType } from "@/types";
import router from "@/router";
import { evaluateUiControls, handleUpdateEvent } from "@/utils";
@Options({
  props: ["disable"],
  components: {
    DemandEdit
  },
  watch: {
    isTaskAnalysis: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.AnalysisOfferTask) {
          this.handleAnalysisData();
        }
      }
    },
    AnalysisOfferTask: {
      handler(newVal) {
        if (newVal && this.isTaskAnalysis) {
          this.handleAnalysisData();
        }
      }
    },
    "$store.state.taskModule.executedAction"(action: ActionType) {
      if (action === ActionType.ANALYSIS ) {
        if (!store.state.taskModule.selectedTask.proceed) {
              store.commit("setLockState", false);
              store.commit("setConfirmationDialogState", {
                show: false,
              });
             router.push("/task/list");
        }
      }
    },
  },
 
  unmounted() {
    store.dispatch("taskModule/analysisModule/initAnalysisState")
  },

  created() {
    evaluateUiControls("analysis-task", 'insert', this.$router, true);
  },
  updated() {
    this.$emit('update');
  },


})
export default class Analyse extends Vue {
  validateForm = false;
  disable: any;
  handleUpdateEvent = handleUpdateEvent;
  handleAnalysisData() {
    if (store.state.analysisModule?.isLoading) {
      return;
    }
    const TaskVariablesState: any = store.state.taskModule.selectedTask?.variables;
    store.dispatch("taskModule/analysisModule/analysis", { data: TaskVariablesState._decisionAnalysisProcessId, isEditing: false, reCalculate: false });
  }

  get AnalysisOfferTask() {
    return store.state.taskModule?.offer?.status?.resourceUid?.includes("ANALYSIS")
  }
  get isTaskAnalysis() {
    return store.getters["taskModule/isTaskAnalysis"];
  }
}
